import { Dispatch } from 'redux'
import { Action } from '../actions/glucoseActions'
import { PaginatedModel } from 'interfaces/pagination'
import { GlucoseRegister } from 'interfaces/glucose'
import { GlucoseActionType } from 'state/action-types/glucoseTypes'

export const paginateGlucose = (data: PaginatedModel<GlucoseRegister>) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: GlucoseActionType.PAGINATE_GLUCOSE,
            payload: data
        })
    }
}